module.exports = __webpack_public_path__ + "img/66.bc73fe11.png";